import { ResponsiveBar } from "@nivo/bar";
import ChartCard from "../../../../shared/charts/ChartCard";

const LEGEND_COLORS = { fulltime: "#3b82f6", talentHub: "#f59e0b", nonBillable: "#94a3b8" };

/**
 * Nivo stacked bar. keys = fulltime, talentHub, nonBillable.
 * Data shape from toHeadcountRows(headcountSeries).
 */
export default function HeadcountChart({ data, canSee, year, activeMonthCounts }) {
  if (!canSee) return null;
  const counts = activeMonthCounts || { fulltime: 0, talentHub: 0, nonBillable: 0, month: "" };
  return (
    <ChartCard
      title={`Headcount — ${year}`}
      subtitle={`Fulltime · Talent Hub · Non-billables (CEO/CCO/CFO/COO/HR)${counts.month ? ` · ${counts.fulltime + counts.talentHub + counts.nonBillable} total in ${counts.month}` : ""}`}
    >
      <div style={{ height: 260 }}>
        <ResponsiveBar
          data={data}
          keys={["fulltime", "talentHub", "nonBillable"]}
          indexBy="month"
          margin={{ top: 12, right: 28, bottom: 36, left: 44 }}
          padding={0.3}
          groupMode="stacked"
          colors={({ id }) => LEGEND_COLORS[id] || "#64748b"}
          axisBottom={{ tickSize: 0, tickPadding: 6 }}
          axisLeft={{ tickSize: 0, tickPadding: 6 }}
          labelSkipWidth={14}
          labelSkipHeight={14}
          enableLabel={false}
          theme={NIVO_DARK_THEME}
          animate={false}
        />
      </div>
      <div style={{ display: "flex", gap: 16, marginTop: 10, fontSize: 11, color: "#8fa4c8" }}>
        <Legend color={LEGEND_COLORS.fulltime} label="Fulltime" value={counts.fulltime} />
        <Legend color={LEGEND_COLORS.talentHub} label="Talent Hub" value={counts.talentHub} />
        <Legend color={LEGEND_COLORS.nonBillable} label="Non-billables" value={counts.nonBillable} />
      </div>
    </ChartCard>
  );
}

function Legend({ color, label, value }) {
  return (
    <div style={{ display: "flex", alignItems: "center", gap: 6 }}>
      <span style={{ width: 10, height: 10, borderRadius: 2, background: color }} />
      {label} <strong style={{ color: "#dce8f8", marginLeft: 4 }}>({value})</strong>
    </div>
  );
}

export const NIVO_DARK_THEME = {
  background: "transparent",
  axis: {
    ticks: {
      text: { fill: "#8fa4c8", fontSize: 11, fontFamily: "'Noto Sans', sans-serif" },
      line: { stroke: "#14213d" },
    },
    domain: { line: { stroke: "#14213d" } },
  },
  grid: { line: { stroke: "#14213d", strokeDasharray: "2 3" } },
  tooltip: {
    container: {
      background: "#070e20", color: "#dce8f8", border: "1px solid #14213d",
      borderRadius: 6, fontSize: 12,
    },
  },
  labels: { text: { fill: "#dce8f8", fontSize: 11 } },
  legends: { text: { fill: "#8fa4c8", fontSize: 11 } },
};
